import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ContactListIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            d='M16.5 5.25C14.9045 5.25 13.1864 5.57727 12 6.47727C10.8136 5.57727 9.09545 5.25 7.5 5.25C5.90455 5.25 4.18636 5.57727 3 6.47727V18.4636C3 18.9955 3.59727 18.8318 3.61364 18.8318C4.71818 18.3 6.31364 17.9318 7.5 17.9318C9.09545 17.9318 10.8136 18.2591 12 19.1591C13.1045 18.4636 15.1091 17.9318 16.5 17.9318C17.85 17.9318 19.2409 18.1773 20.3864 18.7909C20.7218 18.9627 21 18.6355 21 18.4227V6.47727C19.7809 5.56091 18.03 5.25 16.5 5.25ZM19.3636 16.7045C18.4636 16.4182 17.4818 16.2955 16.5 16.2955C15.1091 16.2955 13.1045 16.8273 12 17.5227V8.11364C13.1045 7.41818 15.1091 6.88636 16.5 6.88636C17.4818 6.88636 18.4636 7.00909 19.3636 7.29545V16.7045Z'
        />
    ),
})

ContactListIcon.displayName = 'ContactListIcon'
